import { observer } from 'mobx-react-lite';
import { Trans } from 'react-i18next';
import { ReactComponent as LogoImage } from 'src/icons/logo.svg';
import styled from 'styled-components';

const StyledWrapper = styled.div`
    color: white;
    display: flex;
    align-items: center;
    width: fit-content;
    height: 100%;
    width: 22rem;

    svg {
        width: 7rem;
    }
`;

export const AgentPortalLogo = observer(() => {
    return (
        <StyledWrapper data-testid="app-header-logo">
            <LogoImage data-testid="app-header-logo-image" />
            <StyledText data-testid="app-header-logo-text">
                | <Trans i18nKey="App.Header.AgentLogo.Text" />
            </StyledText>
        </StyledWrapper>
    );
});

const StyledText = styled.div`
    margin-left: 5px;
    font-size: 1.3rem;
    font-weight: 600;
    color: #ababab;
`;
